<template>
    <main-layout>
        <template #header>
            <main-header :title="'Agent 전송 주기 설정'">
            </main-header>
        </template>

        <template #toolbar>
        </template>

        <template #body>
            <div style="flex-grow: 0;">
                <v-tabs
                        v-model="tab"
                        background-color="primary"
                        dark
                >
                    <v-tab
                            v-for="item in tabs"
                            :key="item.key"
                    >
                        {{ item.text }}
                    </v-tab>
                </v-tabs>
            </div>

            <div style="flex-grow: 1; height: calc(100% - 56px);">
                <v-tabs-items v-model="tab" class="fill-height">
                    <v-tab-item
                            class="fill-height"
                            v-for="item in tabs"
                            :key="item.key"
                    >
                        <component :is="item.component"></component>
                    </v-tab-item>
                </v-tabs-items>
            </div>
        </template>
    </main-layout>
</template>

<script>
    import MainHeader from "@/components/common/layout/MainHeader";
    import MainLayout from "@/components/common/layout/MainLayout";
    import MainToolbar from "@/components/common/layout/MainToolbar";
    import MainBody from "@/components/common/layout/MainBody";
    import MonitoringAgentCycleByCountry from "@/views/monitoring/version-deploy/MonitoringAgentCycleByCountry";
    import MonitoringAgentCycleByRentalcompany
        from "@/views/monitoring/version-deploy/MonitoringAgentCycleByRentalcompany";

    const SORT = {
        BY_COUNTRY: "BY_COUNTRY",
        BY_RENTALCOMPANY: "BY_RENTALCOMPANY",
    };

    export default {
        name: "MonitoringAgentDeploy",
        components: {MainBody, MainToolbar, MainLayout, MainHeader},
        data() {
            return {
                tab: SORT.BY_COUNTRY,
                tabs: [
                    {
                        key: SORT.BY_COUNTRY,
                        text: "국가별",
                        component: MonitoringAgentCycleByCountry,
                    },
                    {
                        key: SORT.BY_RENTALCOMPANY,
                        text: "사업자별",
                        component: MonitoringAgentCycleByRentalcompany,
                    },
                ]
            };
        },
    }
</script>

<style scoped>

</style>